<app-grid-filters [gridControl]="gridControl"></app-grid-filters>
<app-grid-actions
  [actions]="gridActions"
  [items]="selectionService.getSelectedItems()"
  (clear)="selectionService.deselectItems($event)"
>
</app-grid-actions>
<app-table
  [appRowActions]="gridActions"
  [expandable]="true"
  [gridControl]="gridControl"
  [selection]="true"
  [value]="pagingList?.items"
>
  <tr
    *appRowDef="let item"
    [class.locked]="item.expired || item.revoked"
    appRow
  ></tr>
  <ng-template
    [header]="'common.profile' | translate"
    appColumn="profile"
    let-item
    size="1"
  >
    <app-table-cell [value]="item.profileCertificate">
      <ng-template>
        <app-ellipsis>
          <app-link [source]="item.profileCertificate"></app-link>
          @if (item.profileCertificateType) {
            <span class="text-color-default">({{ `profile.certificate.form.type.options.${item.profileCertificateType}` | translate }})</span>
          }
        </app-ellipsis>
      </ng-template>
    </app-table-cell>
  </ng-template>
  <ng-template
    [header]="'settings.certificate.issuer' | translate"
    appColumn="issuer"
    let-item
    size="2"
  >
    <app-table-cell [value]="item.signingCertificateName"></app-table-cell>
  </ng-template>
  <ng-template
    [header]="'common.validity' | translate"
    appColumn="validity"
    let-item
    size="1"
  >
    <app-table-cell [value]="item.certificate?.validity"></app-table-cell>
  </ng-template>
  <ng-template
    [header]="'settings.certificate.revoked' | translate"
    appColumn="revoked"
    let-item
    size="1"
  >
    <app-table-cell [value]="item.revoked ? ('settings.certificate.revoked' | translate) : '-'"></app-table-cell>
  </ng-template>
  <ng-template
    appTemplate="rowExpansion"
    let-item
  >
    @if (item.certificate) {
      <div class="p-grid">
        <div class="p-col-12">
          <h4 class="font-weight-bold">{{ 'settings.certificate.certificate' | translate }}</h4>
        </div>
        <ng-container *ngTemplateOutlet="certificate; context: { $implicit: item.certificate }"></ng-container>
      </div>
    }
  </ng-template>
</app-table>

<ng-template
  #certificate
  let-certificate
>
  <div class="p-col-12">
    {{ certificate.distinguishedName }}
  </div>
  <div class="p-col-12">
    <ul class="simple-list">
      @for (item of certificate.subject | keyvalue; track item) {
        <li>
          <span class="font-weight-bold">{{ item.key }}:</span>
          {{ item.value }}
        </li>
      }
    </ul>
  </div>
  <div
    [hidden]="!certificate.extra"
    class="p-col-12"
  >
    <pre>{{ certificate.extra | json }}</pre>
  </div>
</ng-template>
